import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import "./styles.css";
import { captureAttribution } from "./attribution.ts";
import { startActivity } from "./activity.ts";
captureAttribution(); startActivity();

createRoot(document.getElementById("root")!).render(<App />);
if ("serviceWorker" in navigator && import.meta.env.PROD) navigator.serviceWorker.register("/sw.js").catch(() => {});
